import { ObjectRepository } from '@framework/repository';
import { Viewer } from './Viewer';
import type { ViewerJSON, ClientId, ViewModelId } from 'balus-common';
import { RTDBPath } from 'balus-common';

type ViewerRepository = ObjectRepository<ViewerJSON, Viewer>;

export const createViewerRepository = (viewModelId: ViewModelId, clientId: ClientId): ViewerRepository => {
  return new ObjectRepository(Viewer, RTDBPath.ViewModelViewer.viewerPath(viewModelId, clientId));
};
